import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {SelectItem} from 'primeng/api';
import {PolicyDocumentType} from '../../../../shared/types/organization/policy-document-type';
import {AddOrganizationPolicyDocumentService} from '../../../../shared/services/oganization/add-organization-policy-document.service';
import {FormHelperService} from '../../../../shared/services/person/form-helper-service';

@Component({
  selector: 'wsd-add-policy-documents',
  templateUrl: './add-policy-document.component.html',
  styleUrls: ['./add-policy-document.component.css']
})
export class AddPolicyDocumentComponent implements OnInit {

  @Input()
  policyDocumentsCount: number = 0;

  @Output()
  onSave = new EventEmitter<PolicyDocumentType>();

  policyDocumentForm: UntypedFormGroup;

  display: boolean = false;

  policyDocument: PolicyDocumentType;

  orderOptions: SelectItem[] = [];

  constructor(private addService: AddOrganizationPolicyDocumentService,
              private fb: UntypedFormBuilder,
              private formHelper: FormHelperService) {
  }

  ngOnInit() {
    this.policyDocumentForm = this.fb.group({
      documentName: ['', Validators.required],
      documentOrder: ['', Validators.required],
      inactive: [false]
    });
    this.addService.messageSent$.subscribe(
      (policyDocument: PolicyDocumentType) => {
        this.policyDocument = policyDocument;
        this.policyDocumentForm.reset();
        this.policyDocumentForm.patchValue(policyDocument);
        this.initOrder();
        this.display = true;
      }
    );
  }

  initOrder() {
    this.orderOptions = [];
    for (let i = 1; i <= this.policyDocumentsCount + 1; i++) {
      this.orderOptions.push({label: '' + i, value: i});
    }
    if (this.policyDocumentForm.get('documentOrder').value == null) {
      this.policyDocumentForm.get('documentOrder').setValue(this.policyDocumentsCount + 1);
      this.policyDocumentForm.get('documentOrder').updateValueAndValidity();
    }
  }

  save() {
    this.formHelper.validateAllFormFields(this.policyDocumentForm);
    if (this.policyDocumentForm.invalid) {
      return;
    }
    this.policyDocument = {...this.policyDocument, ...this.policyDocumentForm.value};
    this.display = false;
    this.onSave.emit(this.policyDocument);
  }
}
